<template>
<div>
  <el-collapse-header title="Settings">
    <p>Displaying rolling success rate. Data logging started April 1st.</p>

    <el-multi-switch margin-top
      v-model="duration"
      :options="[
        { value: 1, label: '1 day' },
        { value: 7, label: '7 days' }
      ]"
      />
    <el-multi-switch margin-top
      v-model="visitorType"
      :options="[
        { value: 0, label: 'All visitors' },
        { value: 1, label: 'New visitors' },
        { value: 2, label: 'Recurring visitors' }
      ]"
      />
  </el-collapse-header>

  <vue-funnel
    :value="value"
    />

  <br>

  <el-button margin-top secondary danger
    @click="keepAdminLogs = !keepAdminLogs"
    >
    {{ keepAdminLogs ? 'Remove admin data' : 'Include admin data' }}
  </el-button>
</div>
</template>
<script>

import VueFunnel from './VueFunnel.vue'
import dataLog from 'services/dataLog.js'

export default {
  components: { VueFunnel },
  data () {
    return {
      keepAdminLogs: false,
      duration: 7,
      visitorType: 0
    }
  },
  computed: {
    value () {
      const startTimestamp = +(new Date()) - 1000 * 60 * 60 * 24 * this.duration
      const steps = [{
        title: 'HomePage',
        total: 0,
        new: 0
      }, {
        title: 'OrderPage',
        total: 0,
        new: 0
      }, {
        title: 'CheckoutPage',
        total: 0,
        new: 0
      }, {
        title: 'PostPurchasePage',
        total: 0,
        new: 0
      }]

      this.$store.getters.salesFunnel
        .filter(item => !item.isLoggedIn || this.keepAdminLogs)
        .filter(item => item.timestamp > startTimestamp)
        .filter(item => this.visitorType === 0 ||
          (this.visitorType === 1 && item.isNewUser) ||
          (this.visitorType === 2 && !item.isNewUser))
        .forEach(item => {
          steps.forEach(({ title, total }, index) => {
            const hasStep = item.steps.indexOf(title) !== -1

            if (hasStep) {
              steps[index].total++
            }

            if (index !== 0 && hasStep) {
              const prevTitle = steps[index - 1].title

              if (item.steps.indexOf(prevTitle) === -1) {
                steps[index].new++
              }
            }
          })
        })

      return steps
    }
  },
  mounted () {
    dataLog.getSalesFunnel()
  }
}
</script>
